(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TempSectorDeleteController',TempSectorDeleteController);

    TempSectorDeleteController.$inject = ['$uibModalInstance', 'entity', 'TempSector'];

    function TempSectorDeleteController($uibModalInstance, entity, TempSector) {
        var vm = this;
        vm.tempSector = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TempSector.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
